.margint{margin-top:2em}
/*# sourceMappingURL=arterial-blood-gas.component-3CGZHEKM.css.map */
